import { MenuItem, TextField } from '@mui/material';
import { ILanguageCode } from '../../interfaces/languageCode';
import { TEXTS } from '../../core/texts';
import { Validator } from '../../core/Validator';
import { PROFICIENCY_DESCRIPTIONS, PROFICIENCY_MAP } from '../../interfaces/language';
import { ColumnBoxFlexFullWidth } from './boxes';
import { ChangeEvent, useCallback, useMemo } from 'react';
import { BaseObj } from '../../types/baseObj';
import { ValidationErrorState } from '../../types/validationErrorState';
import LanguageAutocomplete from './LanguageAutocomplete';

interface IProps {
  list: ILanguageCode[],
  languageCode: string;
  proficiencyLevel: number;
  languageCodeNamespace?: string;
  proficiencyNamespace?: string;
  onChange: (val: BaseObj) => void;
  validationErrors: ValidationErrorState;
}

export const SelectLanguageAndProficiency = ({
                                               list,
                                               languageCodeNamespace = 'languageCode',
                                               proficiencyNamespace = 'proficiencyLevel',
                                               languageCode,
                                               proficiencyLevel,
                                               onChange,
                                               validationErrors,
                                             }: IProps) => {

  const handleProficiencyChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    onChange({ [name]: value });
  }, [onChange]);

  const proficiencyLevelValue = useMemo(() => proficiencyLevel >= 0 ? proficiencyLevel : '', [proficiencyLevel]);

  return (
    <ColumnBoxFlexFullWidth>
      <LanguageAutocomplete languageCode={languageCode} onChange={onChange} validationErrors={validationErrors}
                            list={list} languageCodeNamespace={languageCodeNamespace}
      />
      <TextField name={proficiencyNamespace} value={proficiencyLevelValue} label={TEXTS.PROFICIENCY} select
                 error={!!validationErrors[proficiencyNamespace]} helperText={validationErrors[proficiencyNamespace]}
                 required={!!Validator.LENGTHS.LANGUAGE[proficiencyNamespace]?.min} onChange={handleProficiencyChange}
                 sx={{ my: 4 }} variant={'standard'}
      >
        {
          Object.values(PROFICIENCY_DESCRIPTIONS).map((description, index) => (
            <MenuItem key={description + index} value={index + 1}>
              {PROFICIENCY_MAP[description]}
            </MenuItem>
          ))
        }
      </TextField>
    </ColumnBoxFlexFullWidth>
  );
};